import React from 'react';
import Button from '../../components/button';

import handleChat from '../../utils/handle-chat';

const features = [
  {
    name: '消息预知',
    price: '10元/月'
  },
  {
    name: '访客拉黑',
    price: '10元/月'
  },
  {
    name: '对话高级分配',
    price: '10元/月'
  },
  {
    name: '询前表单',
    price: '10元/月'
  },
  {
    name: '创建线索',
    price: '10元/月'
  },
  {
    name: '安全设置',
    price: '10元/月'
  },
  {
    name: '对话小结',
    price: '10元/月'
  },
  {
    name: '公众号管理',
    price: '10元/月'
  },
  {
    name: '线索卡片',
    price: '10元/月'
  },
  {
    name: '线索抓取',
    price: '10元/月'
  },
  {
    name: '消息撤回',
    price: '10元/月'
  },
  {
    name: '质检',
    price: '20元/月'
  },
  {
    name: '顾客中心增强',
    price: '20元/月'
  }
];

const Price2 = () => {
  return (
    <div className="price-wrapper">
      <div className="price-header">
        <p>
          进阶套餐<i className="tag">6.5折优惠</i>
        </p>
        <p>包含10个坐席</p>
      </div>
      <div className="price-content">
        <p className="font-24">¥2652元/年</p>
        <p className="count-price">
          <span className="font-36">￥</span>
          <span className="font-68">1588</span>
          <span className="font-16">元/年</span>
        </p>
        <div className="btn">
          <Button type="primary" onClick={() => handleChat('立即购买进阶套餐', ['d8', 'type1'])}>
            立即购买
          </Button>
        </div>
        <p className="desc">
          包含 <i className="tag">入门套餐</i> 功能，以及
        </p>
        <ul>
          {features.map((f, i) => (
            <li key={i}>
              <span>
                <span className="dot" />
                {f.name}
              </span>
              <span>{f.price}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="price-btn">
        <Button onClick={() => handleChat('免费试用进阶套餐', ['d8', 'type2'])}>免费试用</Button>
      </div>
    </div>
  );
};

export default Price2;
